"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_PUBLIC = exports.API_PRIVATE = exports.ALLOWED_HOSTS_TYPE = exports.ROUND_ROBIN_BUCKET_TYPE = exports.STANDARD_BUCKET_TYPE = exports.LIMIT_OPTIONS = exports.AVAILABILITY_OPTIONS = exports.LOCATION_PHONE_CALL_TYPE_INSTANT_OPTIONS = exports.LOCATION_PHONE_CALL_TYPE_OPTIONS = exports.LOCATION_IN_PERSON_TYPE_INSTANT_WITH_LOCATION_OPTIONS = exports.LOCATION_IN_PERSON_TYPE_INSTANT_OPTIONS = exports.LOCATION_IN_PERSON_TYPE_WITH_LOCATION_OPTIONS = exports.LOCATION_IN_PERSON_TYPE_OPTIONS = exports.VIDEO_INTEGRATION_OPTIONS = exports.LOCATION_TYPE_OPTIONS = exports.BUFFER_OPTIONS = exports.DURATION_TIME_UNIT_OPTIONS = exports.DEFAULT_BOOKING_PAGE = exports.DEFAULT_CONFIRMATIONS = exports.DEFAULT_NOTIFICATIONS = exports.DEFAULT_WHO = exports.DEFAULT_WHERE = exports.DEFAULT_SNAP_DURATION = exports.DEFAULT_WHEN = exports.DEFAULT_WHAT = exports.DEFAULT_INPUT_FIELDS = exports.ONE_YEAR_LIMIT_DATE = exports.DEFAULT_CALENDAR_START_AT = void 0;
const constants_1 = require("@/app/shared/constants");
const helpers_1 = require("@/app/shared/helpers");
const labels_1 = __importDefault(require("@/app/shared/i18n/labels"));
const uuid_1 = require("uuid");
const startOfWeek = new Date();
startOfWeek.setHours(0, 0, 0, 0);
startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());
exports.DEFAULT_CALENDAR_START_AT = startOfWeek.getTime();
exports.ONE_YEAR_LIMIT_DATE = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
exports.DEFAULT_INPUT_FIELDS = [
    {
        id: (0, uuid_1.v4)(),
        fieldType: constants_1.CustomFieldType.NAME,
        type: constants_1.CustomType.TEXT,
        enabled: true,
        required: true,
        label: labels_1.default.SCHEDULER_DEFAULT_INVITEE_NAME_LABEL,
    },
    {
        id: (0, uuid_1.v4)(),
        fieldType: constants_1.CustomFieldType.EMAIL,
        type: constants_1.CustomType.TEXT,
        enabled: true,
        required: true,
        label: labels_1.default.SCHEDULER_DEFAULT_INVITEE_EMAIL_LABEL,
    },
];
exports.DEFAULT_WHAT = {
    isActive: true,
    customName: '',
    color: '#039BE5',
    noteFromHost: '',
};
exports.DEFAULT_WHEN = {
    duration: {
        timeUnit: constants_1.TimeUnit.MINUTE,
        count: 30,
    },
    scheduleBuffer: {
        timeUnit: constants_1.TimeUnit.HOUR,
        count: 0,
    },
    dateRange: {
        type: "DAYS_IN_FUTURE" /* SUMO1_server.DateRangeType.DAYS_IN_FUTURE */,
        count: 30,
    },
};
exports.DEFAULT_SNAP_DURATION = `00:${exports.DEFAULT_WHEN.duration.count}:00`;
exports.DEFAULT_WHERE = {
    locationTypes: ["VIDEO_CONFERENCE" /* SchedulerLocationTab.VIDEO_CONFERENCE */],
    defaultLocationType: "VIDEO_CONFERENCE" /* SchedulerLocationTab.VIDEO_CONFERENCE */,
    inPersonType: constants_1.InPersonType.CUSTOM_ADDRESS,
    inPersonTypes: [constants_1.InPersonType.CUSTOM_ADDRESS],
    customAddress: null,
    locations: [],
    phoneCallType: constants_1.PhoneCallType.HOST_PHONE_NUMBER,
    customPhone: '',
    skipTheWhereStep: true,
    customCountryCode: helpers_1.DETECTED_COUNTRY_DATA.code,
};
exports.DEFAULT_WHO = {
    // hostAssignmentMode: AssignmentMode.ROUND_ROBIN,
    hostRescheduleWith: "ASSIGNED_HOST" /* RescheduleWith.ASSIGNED_HOST */,
};
exports.DEFAULT_NOTIFICATIONS = {
    cancelations: {
        enabled: true,
        subject: 'Cancelled: &ltMeeting Name&gt with &ltHost Name&gt at &ltMeeting Time&gt, &ltMeeting Date&gt',
        body: '<p>Hi &ltInvitee Name&gt,</p><br><p>Your meeting &ltMeeting Name&gt with &ltHost Name&gt at &ltMeeting Time&gt, &ltMeeting Date&gt has been cancelled.</p>',
    },
    cancelationsSMS: {
        enabled: false,
        body: 'Hi &ltInvitee Name&gt, your meeting &ltMeeting Name&gt with &ltHost Name&gt at &ltMeeting Time&gt, &ltMeeting Date&gt has been cancelled.',
    },
    confirmations: {
        enabled: true,
        subject: 'New Meeting: &ltMeeting Name&gt with &ltHost Name&gt at &ltMeeting Time&gt, &ltMeeting Date&gt',
        body: '<p>Hi &ltInvitee Name&gt,</p><br><p>Your new meeting &ltMeeting Name&gt with &ltHost Name&gt at &ltMeeting Time&gt, &ltMeeting Date&gt is scheduled.</p><br><p>&ltMeeting Location&gt</p><br><p>&ltNote from Host&gt</p><br><p>&ltNote from Invitee&gt</p><br><p>&ltAdditional Attendees&gt</p><br><p>&ltInvitee Questions&gt</p><br><p>&ltMeeting Button&gt</p><br><p>&ltCancel Policy&gt</p>',
    },
    confirmationsSMS: {
        enabled: false,
        body: 'Hi &ltInvitee Name&gt, your new meeting &ltMeeting Name&gt with &ltHost Name&gt at &ltMeeting Time&gt, &ltMeeting Date&gt is scheduled. View or edit meeting &ltMeeting Link&gt',
    },
    reminders: {
        enabled: false,
        subject: 'Reminder: &ltMeeting Name&gt with &ltHost Name&gt at &ltMeeting Time&gt, &ltMeeting Date&gt',
        body: '<p>Hi &ltInvitee Name&gt,</p><br><p>This is a friendly reminder that your &ltMeeting Name&gt with &ltHost Name&gt is at &ltMeeting Time&gt, &ltMeeting Date&gt.</p><br><p>&ltMeeting Location&gt</p><br><p>&ltMeeting Button&gt</p>',
        timing: [1440],
    },
    remindersSMS: {
        enabled: false,
        body: 'Hi &ltInvitee Name&gt, this is a friendly reminder that your &ltMeeting Name&gt with &ltHost Name&gt is at &ltMeeting Time&gt, &ltMeeting Date&gt. View or edit meeting &ltMeeting Link&gt',
        timing: [1440],
    },
    reschedule: {
        enabled: true,
        subject: 'Rescheduled: &ltMeeting Name&gt with &ltHost Name&gt at &ltMeeting Time&gt, &ltMeeting Date&gt',
        body: '<p>Hi &ltInvitee Name&gt,</p><br><p>Your meeting &ltMeeting Name&gt with &ltHost Name&gt is rescheduled.</p><br><p><b>Updated Time and Date</b></p><p>&ltMeeting Time&gt, &ltMeeting Date&gt</p><br><p>&ltMeeting Location&gt</p><br><p>&ltMeeting Button&gt</p>',
    },
    rescheduleSMS: {
        enabled: false,
        body: 'Hi &ltInvitee Name&gt, your meeting &ltMeeting Name&gt with &ltHost Name&gt is rescheduled. Updated Time and Date &ltMeeting Time&gt, &ltMeeting Date&gt. View or edit meeting &ltMeeting Link&gt',
    },
    followUp: {
        enabled: false,
        subject: 'Follow-Up: &ltMeeting Name&gt with &ltHost Name&gt at &ltMeeting Time&gt, &ltMeeting Date&gt',
        body: '<p>Hi &ltInvitee Name&gt,</p><br><p>We hope your meeting &ltMeeting Name&gt with &ltHost Name&gt at &ltMeeting Time&gt, &ltMeeting Date&gt was productive.</p><br><p>If you have any feedback or need further assistance, please feel free to reach out to us.</p><br><p></p>',
        timing: [1440],
    },
    smsReminder: {
        enabled: false,
        body: 'This is a friendly reminder that your &ltMeeting Name&gt with &ltHost Name&gt is at &ltMeeting Time&gt, &ltMeeting Date&gt. View or edit meeting &ltMeeting Link&gt',
        timing: [1440],
    },
};
exports.DEFAULT_CONFIRMATIONS = {
    type: "OUR_PAGE" /* ConfirmationsPageType.OUR_PAGE */,
    externalLink: null,
    anotherEventEnabled: true,
    rescheduleEnabled: true,
    cancelEnabled: true,
    customLinks: null,
};
exports.DEFAULT_BOOKING_PAGE = {
    id: '',
    workspaceId: '',
    inviteOthers: false,
    enterNote: false,
    adminOnly: false,
    allUsers: false,
    calendar: {
        timeFormat: constants_1.TimeFormat.HOUR_12,
        calendarFormat: constants_1.CalendarFormat.MONTH_VIEW,
        timeInterval: constants_1.DEFAULT_INTERVAL_COUNT,
        topOfInterval: false,
        timeZoneType: constants_1.TimeZoneType.DETECT_INVITEE,
        selectedTimeZone: [],
    },
    smartAlertIds: [],
    inputFields: exports.DEFAULT_INPUT_FIELDS,
    what: exports.DEFAULT_WHAT,
    when: exports.DEFAULT_WHEN,
    where: exports.DEFAULT_WHERE,
    who: exports.DEFAULT_WHO,
    guestsLimit: undefined,
    notifications: exports.DEFAULT_NOTIFICATIONS,
    confirmationsPage: exports.DEFAULT_CONFIRMATIONS,
    version: 0,
    lastModify: 'SUMO1 System',
};
exports.DURATION_TIME_UNIT_OPTIONS = [
    { value: constants_1.TimeUnit.MINUTE, label: labels_1.default.SCHEDULER_DURATION_DIMENSION_MINUTES_FULL_LABEL },
    { value: constants_1.TimeUnit.HOUR, label: labels_1.default.SCHEDULER_DURATION_DIMENSION_HOURS_FULL_LABEL },
];
exports.BUFFER_OPTIONS = [
    { value: "NONE" /* SchedulerBufferTime.NONE */, label: labels_1.default.SCHEDULER_BUFFER_TIME_NONE_LABEL },
    { value: "MINUTE5" /* SchedulerBufferTime.MINUTE5 */, label: labels_1.default.SCHEDULER_BUFFER_TIME_MIN5_LABEL },
    { value: "MINUTE10" /* SchedulerBufferTime.MINUTE10 */, label: labels_1.default.SCHEDULER_BUFFER_TIME_MIN10_LABEL },
    { value: "MINUTE15" /* SchedulerBufferTime.MINUTE15 */, label: labels_1.default.SCHEDULER_BUFFER_TIME_MIN15_LABEL },
    { value: "MINUTE20" /* SchedulerBufferTime.MINUTE20 */, label: labels_1.default.SCHEDULER_BUFFER_TIME_MIN20_LABEL },
    { value: "MINUTE25" /* SchedulerBufferTime.MINUTE25 */, label: labels_1.default.SCHEDULER_BUFFER_TIME_MIN25_LABEL },
    { value: "MINUTE30" /* SchedulerBufferTime.MINUTE30 */, label: labels_1.default.SCHEDULER_BUFFER_TIME_MIN30_LABEL },
    { value: "MINUTE35" /* SchedulerBufferTime.MINUTE35 */, label: labels_1.default.SCHEDULER_BUFFER_TIME_MIN35_LABEL },
    { value: "MINUTE40" /* SchedulerBufferTime.MINUTE40 */, label: labels_1.default.SCHEDULER_BUFFER_TIME_MIN40_LABEL },
    { value: "MINUTE45" /* SchedulerBufferTime.MINUTE45 */, label: labels_1.default.SCHEDULER_BUFFER_TIME_MIN45_LABEL },
    { value: "MINUTE50" /* SchedulerBufferTime.MINUTE50 */, label: labels_1.default.SCHEDULER_BUFFER_TIME_MIN50_LABEL },
    { value: "MINUTE55" /* SchedulerBufferTime.MINUTE55 */, label: labels_1.default.SCHEDULER_BUFFER_TIME_MIN55_LABEL },
    { value: "MINUTE60" /* SchedulerBufferTime.MINUTE60 */, label: labels_1.default.SCHEDULER_BUFFER_TIME_MIN60_LABEL },
];
exports.LOCATION_TYPE_OPTIONS = [
    { value: "VIDEO_CONFERENCE" /* SchedulerLocationTab.VIDEO_CONFERENCE */, label: labels_1.default.SCHEDULER_LOCATION_VIDEO_CONFERENCE },
    { value: "PHONE_CALL" /* SchedulerLocationTab.PHONE_CALL */, label: labels_1.default.SCHEDULER_LOCATION_PHONE },
    { value: "IN_PERSON" /* SchedulerLocationTab.IN_PERSON */, label: labels_1.default.SCHEDULER_LOCATION_IN_PERSON },
];
exports.VIDEO_INTEGRATION_OPTIONS = [
    { value: "GOOGLE_MEET" /* VideoIntegrationType.GOOGLE_MEET */, label: labels_1.default.SCHEDULER_LOCATION_INTEGRATION_GOOGLE_MEET_LABEL },
    { value: "MICROSOFT_TEAMS" /* VideoIntegrationType.MICROSOFT_TEAMS */, label: labels_1.default.SCHEDULER_LOCATION_INTEGRATION_MICROSOFT_TEAMS_LABEL },
    { value: "ZOOM" /* VideoIntegrationType.ZOOM */, label: labels_1.default.SCHEDULER_LOCATION_INTEGRATION_ZOOM_LABEL },
];
exports.LOCATION_IN_PERSON_TYPE_OPTIONS = [
    { value: constants_1.InPersonType.CUSTOM_ADDRESS, label: labels_1.default.SCHEDULER_LOCATION_IN_PERSON_CUSTOM_ADDRESS },
    { value: constants_1.InPersonType.INVITEE_LOCATION, label: labels_1.default.SCHEDULER_LOCATION_IN_PERSON_INVITEE_LOCATION },
];
exports.LOCATION_IN_PERSON_TYPE_WITH_LOCATION_OPTIONS = [
    ...exports.LOCATION_IN_PERSON_TYPE_OPTIONS,
    { value: constants_1.InPersonType.LOCATION, label: labels_1.default.SCHEDULER_LOCATION_IN_PERSON_LOCATION },
];
exports.LOCATION_IN_PERSON_TYPE_INSTANT_OPTIONS = [
    { value: constants_1.InPersonType.CUSTOM_ADDRESS, label: labels_1.default.SCHEDULER_LOCATION_IN_PERSON_CUSTOM_ADDRESS },
];
exports.LOCATION_IN_PERSON_TYPE_INSTANT_WITH_LOCATION_OPTIONS = [
    ...exports.LOCATION_IN_PERSON_TYPE_INSTANT_OPTIONS,
    { value: constants_1.InPersonType.LOCATION, label: labels_1.default.SCHEDULER_LOCATION_IN_PERSON_LOCATION },
];
exports.LOCATION_PHONE_CALL_TYPE_OPTIONS = [
    { value: "HOST_PHONE_NUMBER" /* SchedulerLocationPhoneTab.HOST_PHONE_NUMBER */, label: labels_1.default.SCHEDULER_LOCATION_PHONE_HOST_PHONE },
    { value: "PROMPT_INVITE" /* SchedulerLocationPhoneTab.PROMPT_INVITE */, label: labels_1.default.SCHEDULER_LOCATION_PHONE_INVITEE_PHONE },
    { value: "CUSTOM_PHONE" /* SchedulerLocationPhoneTab.CUSTOM_PHONE */, label: labels_1.default.SCHEDULER_LOCATION_PHONE_CUSTOM_PHONE },
];
exports.LOCATION_PHONE_CALL_TYPE_INSTANT_OPTIONS = [
    { value: "HOST_PHONE_NUMBER" /* SchedulerLocationPhoneTab.HOST_PHONE_NUMBER */, label: labels_1.default.SCHEDULER_LOCATION_PHONE_HOST_PHONE },
    { value: "CUSTOM_PHONE" /* SchedulerLocationPhoneTab.CUSTOM_PHONE */, label: labels_1.default.SCHEDULER_LOCATION_PHONE_CUSTOM_PHONE },
];
exports.AVAILABILITY_OPTIONS = [
    { value: "OPEN" /* SchedulerAvailability.OPEN */, label: labels_1.default.SCHEDULER_AVAILABILITY_OPEN },
    { value: "CUSTOM" /* SchedulerAvailability.CUSTOM */, label: labels_1.default.SCHEDULER_AVAILABILITY_CUSTOM },
    { value: "ROLLING" /* SchedulerAvailability.ROLLING */, label: labels_1.default.SCHEDULER_AVAILABILITY_ROLLING },
    { value: "RANGE" /* SchedulerAvailability.RANGE */, label: labels_1.default.SCHEDULER_AVAILABILITY_RANGE },
];
exports.LIMIT_OPTIONS = [
    { value: "LIMIT1" /* SchedulerLimit.LIMIT1 */, label: labels_1.default.SCHEDULER_LIMIT_LIMIT1_LABEL },
    { value: "LIMIT2" /* SchedulerLimit.LIMIT2 */, label: labels_1.default.SCHEDULER_LIMIT_LIMIT2_LABEL },
    { value: "LIMIT3" /* SchedulerLimit.LIMIT3 */, label: labels_1.default.SCHEDULER_LIMIT_LIMIT3_LABEL },
    { value: "LIMIT4" /* SchedulerLimit.LIMIT4 */, label: labels_1.default.SCHEDULER_LIMIT_LIMIT4_LABEL },
    { value: "LIMIT5" /* SchedulerLimit.LIMIT5 */, label: labels_1.default.SCHEDULER_LIMIT_LIMIT5_LABEL },
    { value: "LIMIT6" /* SchedulerLimit.LIMIT6 */, label: labels_1.default.SCHEDULER_LIMIT_LIMIT6_LABEL },
    { value: "LIMIT7" /* SchedulerLimit.LIMIT7 */, label: labels_1.default.SCHEDULER_LIMIT_LIMIT7_LABEL },
    { value: "LIMIT8" /* SchedulerLimit.LIMIT8 */, label: labels_1.default.SCHEDULER_LIMIT_LIMIT8_LABEL },
    { value: "LIMIT9" /* SchedulerLimit.LIMIT9 */, label: labels_1.default.SCHEDULER_LIMIT_LIMIT9_LABEL },
    { value: "LIMIT10" /* SchedulerLimit.LIMIT10 */, label: labels_1.default.SCHEDULER_LIMIT_LIMIT10_LABEL },
    { value: "UNLIMITED" /* SchedulerLimit.UNLIMITED */, label: labels_1.default.SCHEDULER_LIMIT_UNLIMITED_LABEL },
];
exports.STANDARD_BUCKET_TYPE = 'STANDARD';
exports.ROUND_ROBIN_BUCKET_TYPE = 'ROUND_ROBIN';
exports.ALLOWED_HOSTS_TYPE = 'WHO_SECTION_AND_ADDED_USERS_OR_TEAMS';
exports.API_PRIVATE = '/api/public';
exports.API_PUBLIC = '/public';
